import generateShade from "@helpers/generateShade";
import { ColorShade } from "@template/theme";

export const colorTypes: ColorShade[] = [
  0, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950,
];

const generateDefaultShades = ({
  color,
  baseColor,
  darkMode,
}: {
  color: string;
  baseColor?: string;
  darkMode?: boolean;
}) => {
  let shades = colorTypes.reduce((acc, num) => {
    acc[num] = generateShade({
      color,
      shade: num as number,
      darkMode,
      baseColor: baseColor,
    });
    return acc;
  }, {});
  shades["default"] = color;

  return shades;
};

export default generateDefaultShades;
